

































import Vue from "vue";
import { Dashboard, DashLayout, DashItem } from "vue-responsive-dash";
import { Component } from "vue-property-decorator";
import { http } from "@/shared/https";
import Axios from "axios";
@Component({
  components: {}
})
export default class ApplicantDashboardComponent extends Vue {
  items: any = [];
  headers: any = [];
  headersSeparator: any = [];
  inset: boolean = true;
  data() {
    return { items: this.items };
  }

  redirectToLogin() {
    this.$router.push("/gmsdashboard");
  }

  redirectToRegister() {
    this.$router.push("/Registration");
  }
}
